import { offlineDatabase } from '../database/offlineDatabase/offlineDatabase';
import { createOfflineCommonRepository } from './common/createOfflineCommonRepository';

export const offlineStocksRepository = {
  ...createOfflineCommonRepository(() => offlineDatabase.stocks),
  findByProductColorId: ({ productColorId }: FindByProductColorIdParams) => {
    return offlineDatabase.stocks
      .filter((stock) => stock.productColorId === productColorId)
      .toArray();
  },
};

interface FindByProductColorIdParams {
  productColorId: string;
}
